/*
 * Copyright (c) 2025 CalAmp Corp.  All Rights Reserved
 */
import {convertSvgToDataUri} from '@ion/core/src/utils/Encoding';
import {dlsColor} from '@ion/dls/src/theme/theme';

export interface InputEventMarker {
  size?: number,
  borderColor?: string,
  fillColor?: string
};

/**
 * Utility function that returns an image from SVG that can be passed
 * to the esri Graphic constructor to make a graphic for input events of the asset
 *
 * ```typescript
 *  import {getInputEventMarker} from '@ion/dls/src/maps/markers';
 *
 *  return {
 *    type   : 'picture-marker',
 *    url    : getInputEventMarker({size, fillColor}),
 *    width  : size,
 *    height : size,
 *    angle  : 0
 * }
 * ```
 */
export const getInputEventMarker = ({
  fillColor = dlsColor('electricPurple'),
  borderColor = dlsColor('white'),
  size = 24
}: InputEventMarker) => {
  const svg = (`
    <svg width='${size}' height='${size}' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path fill-rule='evenodd' clip-rule='evenodd' d='M12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C23.9927 5.37563 18.6244 0.00734817 12 0Z' fill='${borderColor}'/>
      <path fill-rule='evenodd' clip-rule='evenodd' d='M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2.00619 17.5203 6.47972 21.9938 12 22V22Z' fill='${fillColor}'/>
      <circle cx='12' cy='12' r='10' fill='#C629DD'/>
      <path d='M9 7C8.08852 7.50427 7.33107 8.23226 6.80427 9.11026C6.27748 9.98826 6 10.9851 6 12C6 13.0149 6.27748 14.0118 6.80427 14.8898C7.33107 15.7678 8.08852 16.4957 9 17' stroke='white' stroke-width='2' stroke-miterlimit='10' stroke-linecap='round'/>
      <path d='M15 7C15.9115 7.50427 16.6689 8.23226 17.1957 9.11026C17.7225 9.98826 18 10.9851 18 12C18 13.0149 17.7225 14.0118 17.1957 14.8898C16.6689 15.7678 15.9115 16.4957 15 17' stroke='white' stroke-width='2' stroke-miterlimit='10' stroke-linecap='round'/>
      <circle cx='12' cy='12' r='2' fill='${borderColor}' stroke='white'/>
    </svg>
  `);
  return convertSvgToDataUri(svg.trim());
};

export default getInputEventMarker;
